import { ITenantStoreSegment } from './tenant.interface';

export const tenantStoreSelector = (state: ITenantStoreSegment) => state.tenant;
